import * as React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process, State, DataResult } from "@progress/kendo-data-query"
import "@progress/kendo-theme-material/dist/all.css";
// import { UiAccordian } from "../../_uiComponents/common/form/UiToggleArea";
// import SalesDataManagementFilterForm from "./forms/SalesDataManagementFilterForm";
// import { SearchBarWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import { UiSwitch } from "../../../../../_uiComponents/telerikComponents/UiSwitch";

const products = [
    {
        id: 1,
        rewardName: "File Type 1",
        rewardValue:'application 1',
        allocatedQty: '10/30/2024',
        issuedQty: '10/30/2024',
        remainingQty: '100',
        winning: true,
        active:true
    },
    {
        id: 2,
        rewardName: "File Type 1",
        rewardValue:'application 1',
        allocatedQty: '10/30/2024',
        issuedQty: '10/30/2024',
        remainingQty: '100',
        winning: true,
        active:true
    },
    {
        id: 3,
        rewardName: "File Type 1",
        rewardValue:'application 1',
        allocatedQty: '10/30/2024',
        issuedQty: '10/30/2024',
        remainingQty: '100',
        winning: true,
        active:true
    },
    {
        id: 4,
        rewardName: "File Type 1",
        rewardValue:'application 1',
        allocatedQty: '10/30/2024',
        issuedQty: '10/30/2024',
        remainingQty: '100',
        winning: true,
        active:true
    },

]

const initialDataState = {
    skip: 0,
    take: 3,
};

const initialSort = [
    {
        field: "application",
        dir: "asc",
    },
];

const GamePlayRewardPotConfiguration = () => {
    const [page, setPage] = React.useState(initialDataState);
    const [sort, setSort] = React.useState(initialSort);
    const [pageSizeValue, setPageSizeValue] = React.useState();
    const [dataState, setDataState] = React.useState();
    const [resultState, setResultState] = React.useState(
        process(products, initialDataState)
    );

    const pageChange = (event) => {
        const targetEvent = event.targetEvent;
        setResultState(process(products, event.page.skip, event.page.take));
        const take =
            targetEvent.value === "All" ? products.length : event.page.take;
        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take,
        });
    };

    const onDataStateChange = React.useCallback((e) => {
        setDataState(e.dataState);
        setSort(e.sort);
        setResultState(process(products, e.dataState));

    }, []);



    const WinningCell = (props) => {
        return (
            <td
                {...props.tdProps}
                className="sba-telerik-grid-button"
            >
                <UiSwitch />
            </td>
        );
    };

    const ActiveCell = (props) => {
        return (
            <td
                {...props.tdProps}
                className="sba-telerik-grid-button"
            >
                <UiSwitch />
            </td>
        );
    };


    return (
        <div className='sba-telerik-components-wr'>
            {/* <UiAccordian>
                <SearchBarWr>
                    <SalesDataManagementFilterForm />
                </SearchBarWr>
            </UiAccordian> */}
            <Grid
                data={resultState.data.slice(page.skip, page.take + page.skip)}
                skip={page.skip}
                take={page.take}
                total={products.length}
                sortable={true}
                fixedScroll={true}
                sort={sort}
                {...dataState}
                onPageChange={pageChange}
                onDataStateChange={onDataStateChange}

            >
                <GridColumn field="rewardName" title="Reward Name"  width="200px"/>
                <GridColumn field="rewardValue" title="Reward & Value" width="200px"/>
                <GridColumn field="allocatedQty" title="Allocated Qty" width="200px"/>
                <GridColumn field="issuedQty" title="Issued Qty" width="200px"/>
                <GridColumn field="remainingQty" title="Remaining Qty" width="200px"/>
                <GridColumn field="winning" title="Winning" width="100px" cells={{
                    data: WinningCell
                }} />
                <GridColumn field="active" title="Active" width="100px" cells={{
                    data: ActiveCell
                }} />
               
            </Grid>
        </div>
    );
};
export default GamePlayRewardPotConfiguration;
